import { Helmet } from "react-helmet";
import {
  Autocomplete,
  Box,
  Button,
  Container,
  Checkbox,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  FormControl,
  Grid,
  InputLabel,
  Menu,
  MenuItem,
  Paper,
  Select,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tabs,
  TextField,
  Toolbar,
  Typography,
  Avatar,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { makeStyles, withStyles } from "@mui/styles";
import React, { useEffect } from "react";
import cssVariables from "../../theme/cssVariables";
import CloseIcon from "../../assets/images/plus-circle-fill.svg";
import linkedGoal from "../../assets/images/linkedGoal.svg";
import defaultProfile from "../../assets/images/defaultProfile.svg";
import arrowLinkedGoal from "../../assets/images/arrowLinkedGoal.svg";
import kpiArrow from "../../icons/kpiArrow.svg";
import * as Util from "../../services/global.service";
const useStyles = makeStyles({
  boxLeft: {
    width: "25%",
    "padding-bottom": "25px",
  },
  boxRight: {
    width: "75%",
    "padding-bottom": "25px",
  },
});


const DefaultForm = (props) => {
  const { name, proficiency, description, scale, open, close, data } = props

  const classes = useStyles();
  const { t } = useTranslation()

  const [competencyDescription, setCompetencyDescription] = React.useState('')
  const [dataRating, setDataRating] = React.useState([
    {
      serial: "2",
      scale_level: "1",
      value: "1",
      description: {
        title: "Need Improvement",
        sub_title: [
        ]
      }
    },
    {
      serial: "3",
      scale_level: "2",
      value: "2",
      description: {
        title: "Below Expectations",
        sub_title: [
        ]
      }
    },
    {
      serial: "4",
      scale_level: "3",
      value: "3",
      description: {
        title: "Meet Expectations",
        sub_title: [
        ]
      }
    },
    {
      serial: "5",
      scale_level: "4",
      value: "4",
      description: {
        title: "Exceed Expectations",
        sub_title: [
        ]
      }
    },
    {
      serial: "6",
      scale_level: "5",
      value: "5",
      description: {
        title: "Outstanding",
        sub_title: [
        ]
      }
    },
  ]);
  const handleCloseDialog = () => {
    close(false);
  };

  useEffect(() => {
    let content = ''
    if (description) {
      content = description.replace(/\n/g, "<br/>")
    }

    setCompetencyDescription(content)
  }, [description])

  return (
    <Dialog onBackdropClick={() => { return false }} open={open} onClose={handleCloseDialog} aria-labelledby="form-dialog-title" fullWidth={true} maxWidth="lg" PaperProps={{ sx: { padding: '30px 30px 15px' } }}>
      <DialogTitle id="form-add-dialog-title" fontSize={24} lineHeight="26.4px" sx={{ padding: "0 0 20px" }}>
        {t('evaluation.competencyDetail')}
        <Box sx={{ position: "absolute", right: 0, margin: "30px 30px 0  0", top: 0 }}><img onClick={handleCloseDialog} className="clickable" src={CloseIcon} alt="browser" /></Box>
      </DialogTitle>
      <Divider />
      <DialogContent sx={{ padding: "0", "overflow-y": "unset" }}>
        <Box sx={{ display: "flex", "flex-flow": "row wrap", paddingTop: "35px" }}>
          <Box className={classes.boxLeft}>
            <Typography fontSize={18} lineHeight="26.91px" color="#A3A3A3">
              {t('evaluation.competencyName')}
            </Typography>
          </Box>
          <Box className={classes.boxRight}>
            <Typography fontSize={18} lineHeight="26.91px" color="#404349">
              {name}
            </Typography>
          </Box>
          <Box className={classes.boxLeft}>
            <Typography fontSize={18} lineHeight="26.91px" color="#A3A3A3">
              {t('evaluation.proficiencyCompetency')}
            </Typography>
          </Box>
          <Box className={classes.boxRight}>

            <Typography fontSize={18} lineHeight="26.91px" color="#404349">
              {proficiency?.level !== undefined && proficiency?.level !== "" && proficiency?.description !== undefined && proficiency?.description !== "" ?
                `Level ${Util.formatData(proficiency?.level, "-")} - ${Util.formatData(proficiency?.description, "-")}` :
                "-"}
            </Typography>
          </Box>
          <Box className={classes.boxLeft}>
            <Typography fontSize={18} lineHeight="26.91px" color="#A3A3A3">
              {t('evaluation.description')}
            </Typography>
          </Box>
          <Box className={classes.boxRight}>
            <Typography fontSize={18} lineHeight="26.91px" color="#404349" dangerouslySetInnerHTML={{ __html: competencyDescription }}></Typography>
          </Box>
        </Box>
        <Box>
          <Typography fontSize={18} lineHeight="26.91px" color="#A3A3A3">
            {t('evaluation.ratingInformation')}
          </Typography>
        </Box>
        <Box pt="25px">
          <TableContainer>
            <Table aria-label="simple table">
              <TableHead>
                <TableRow sx={{ borderBottom: "0.5px solid #E4E4E4", borderTop: "0.5px solid #E4E4E4", background: "#FAFAFA" }}>
                  <TableCell sx={{ whiteSpace: "nowrap", width: "5%" }}><Typography variant="label" fontSize={16} fontWeight={500} lineHeight="21.86px" color="#A0A0A0"> {t('evaluation.scaleLevel')}</Typography></TableCell>
                  <TableCell sx={{ whiteSpace: "nowrap", width: "5%" }}><Typography variant="label" fontSize={16} fontWeight={500} lineHeight="21.86px" color="#A0A0A0"> {t('evaluation.value')}</Typography></TableCell>
                  <TableCell sx={{ whiteSpace: "nowrap", width: "90%" }}><Typography variant="label" fontSize={16} fontWeight={500} lineHeight="21.86px" color="#A0A0A0"> {t('evaluation.description')}</Typography></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {scale !== undefined && scale !== null && scale.length > 0 ?
                  scale.map(item => (
                    <TableRow>
                      <TableCell component="th" scope="row" sx={{ paddingBottom: "10px" }}>
                        <Typography fontSize={16} lineHeight="23.92px">{item?.level}</Typography>
                      </TableCell>
                      <TableCell component="th" scope="row" sx={{ paddingBottom: "10px" }}>
                        <Typography fontSize={16} lineHeight="23.92px">{item?.value}</Typography>
                      </TableCell>
                      <TableCell component="th" scope="row" sx={{ paddingBottom: "10px" }}>
                        <Typography fontSize={18} lineHeight="26.91px" dangerouslySetInnerHTML={{ __html: item?.description }}></Typography>
                      </TableCell>
                    </TableRow>
                  )) : null
                }
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </DialogContent>
    </Dialog>
  );
};
export default DefaultForm;
